<template>
  <el-container style="border: 1px solid #eee">
    <el-main>
      <CreatedForm insite="true" ref="dataForm" v-if="showViewFormData.list && showViewFormData.list.length > 0"
                   :data="showViewFormData" :value="temp" :soltNameArray="soltNameArray">
        <el-input slot="planCode" v-model="planCodeModel"/>
      </CreatedForm>
    </el-main>
  </el-container>
</template>

<script>

import * as forms from '@/api/forms';
import CreatedForm from '@/components/Formcreated/components/CreatedForm';

export default {
  name: 'productionplansdetail',
  components: { CreatedForm },
  props: ['frmData'],
  data() {
    return {
      temp: {},
      showViewFormData: [],
      planCodeModel: '',
      soltNameArray: ['planCode']
    };
  },
  computed: {
    commonObject: function() {
      return JSON.parse(this.frmData);
    }
  },
  created() {
    this.InitDate();
  },
  methods: {
    InitDate() {
      this.temp = { ...this.temp, ...this.commonObject };
      this.planCodeModel = this.temp.planCode;
      var queryObj = { SourceCode: 'ProductionPlan' };
      forms.getCreeateFrom(queryObj).then(response => {
        this.showViewFormData = response.result.contentData && JSON.parse(response.result.contentData) || {};
      }).catch(() => {
        // console.log(err)
      });
    },
    handleClick(tab, event) {
      // console.log(tab, event)
    }
  },
  mounted() {
    // console.log('-------------------' + this.frmData)
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

.createPost-container {
  position: relative;

  .createPost-main-container {
    margin: 10px;
    background-color: white;
    padding: 10px;
    padding-top: 0;

    .postInfo-container {
      position: relative;
      @include clearfix;
      margin-bottom: 10px;

      .postInfo-container-item {
        float: left;
      }
    }

    .editor-container {
      min-height: 500px;
      margin: 0 0 30px;

      .editor-upload-btn-container {
        text-align: right;
        margin-right: 10px;

        .editor-upload-btn {
          display: inline-block;
        }
      }
    }
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .word-counter {
    width: 40px;
    position: absolute;
    right: -10px;
    top: 0px;
  }
}
</style>
